export enum EPlatform {
  twitch = 'twitch',
  instagram = 'instagram',
  youtube = 'youtube',
  tiktok = 'tiktok',
  facebook = 'facebook',
  x = 'x',
}

export enum EPlatformFeature {
  twitchStream = 'twitchStream',
  instagramPost = 'instagramPost',
  instagramReel = 'instagramReel',
  instagramStory = 'instagramStory',
  tiktokPost = 'tikTokPost',
  youtubeStream = 'youtubeStream',
  youtubeVod = 'youtubeVod',
  youtubeShort = 'youtubeShort',
  facebookPost = 'facebookPost',
  facebookVideo = 'facebookVideo',
  xPost = 'xPost',
}

export enum EDeliverableType {
  title = 'title',
  gamePlay = 'gamePlay',
  chatBot = 'chatBot',
  chatbotMulti = 'chatbotMulti',
  talkingPoint = 'talkingPoint',
  talkingPointAi = 'talkingPointAi',
  visual = 'visual',
  productPlacement = 'productPlacement',
  showcase = 'showcase',
  textTracking = 'textTracking',
  audioTracking = 'audioTracking',
  caption = 'caption',
  hashTag = 'hashTag',
  mention = 'mention',
  message = 'message',
  description = 'description',
  content = 'content',
  custom = 'custom',
}

export enum ECampaignStatus {
  draft = 'Draft',
  planned = 'Planned',
  live = 'Live',
  ended = 'Ended',
  archived = 'Archived',
}

export enum EOverwriteStatus {
  overwritten = 'Overwritten',
  deleted = 'Deleted',
}

export enum ECurrency {
  usd = 'USD',
  eur = 'EUR',
}
